import { render, staticRenderFns } from "./applicationH5.vue?vue&type=template&id=5bd11fc5&scoped=true&lang=pug"
import script from "./applicationH5.vue?vue&type=script&lang=js"
export * from "./applicationH5.vue?vue&type=script&lang=js"
import style0 from "./applicationH5.vue?vue&type=style&index=0&id=5bd11fc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd11fc5",
  null
  
)

export default component.exports